module.exports = __webpack_public_path__ + "4e65eba55a7034ff7b33b2a285c7aa14.pdf";